//=== Cube Forms
// Inspired by HTMLForms: https://github.com/ibericode/html-forms/blob/master/assets/browserify/public.js

import Loader from './form-loading-indicator';
import './file-upload';

const config = window.cube_forms_config || {};

function clearFormMessages (formEl) {
  const messageElements = formEl.querySelectorAll('.cube-form-message');
  [].forEach.call(messageElements, (el) => {
    el.parentNode.removeChild(el);
  });
}

function addFormMessage (formEl, message, clear) {
  const msgElement = document.createElement('div');
  msgElement.className = 'cube-form-message cube-form-message-' + message.type;
  msgElement.innerHTML = message.text; // uses innerHTML because we allow some HTML strings in the message settings
  msgElement.role = 'alert';

  let wrapperElement = formEl.querySelector('.cube-form-messages');

  // If messages wrapper is missing, add it
  if (!wrapperElement) {
    wrapperElement = document.createElement('div');
    wrapperElement.className = 'cube-form-messages';
    formEl.appendChild(wrapperElement);
    console.log('wrapper was missing...', wrapperElement);
  }

  if (clear) {
    wrapperElement.innerHTML = '';
  }

  wrapperElement.appendChild(msgElement);
  wrapperElement.classList.remove('hidden'); // Unhide messages

  // Finally, scroll to the message in case it isn't in view
  setTimeout(function() {
    let headerHeight = document.querySelector('header.site').offsetHeight || 0; // Need to account for fixed header when scrolling up
    let wrapperOffsetTop = Math.max(0, wrapperElement.getBoundingClientRect().top + window.scrollY - headerHeight);
    window.scrollTo({...{top: wrapperOffsetTop}, ...{behavior: 'smooth'}});
  }, 50);
}

function handleSubmitEvents (e) {
  const formEl = e.target;
  if (formEl.className.indexOf('cube-form') < 0) {
    return
  }
  e.preventDefault(); // always prevent default because we only want to send via AJAX
  submitForm(formEl)
}

function submitForm(form) {
  const formData = new FormData(form);

  formData.append('action', config.action);
  formData.append('nonce', config.nonce);

  let request = new XMLHttpRequest();
  request.onreadystatechange = createRequestHandler(form);
  request.open('POST', config.ajax_url, true);
  request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  request.send(formData);
  request = null;
}

function createRequestHandler (formEl) {
  const loader = new Loader(formEl);
  loader.start();

  return function () {
    // Is the XHR request complete? https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState
    if (this.readyState === 4) {
      let response;
      loader.stop();

      if (this.status >= 200 && this.status < 400) {

        try {
          response = JSON.parse(this.responseText);
        } catch (error) {
          console.log('Cube Forms: failed to parse AJAX response.\n\nError: "' + error + '"');
          return;
        }

        // Show form message
        if (response.message) {
          let clearMessages = response.message.type === 'error';
          addFormMessage(formEl, response.message, clearMessages);
        }

        // Should we hide form?
        if (response.hide_form) {
          formEl.querySelector('.cube-form-content').style.display = 'none'
        }

        // Should we redirect?
        if (response.redirect_url) {
          window.location = response.redirect_url
        }

        // Clear form
        // if (!response.error) {
        //   formEl.reset()
        // }
      } else {
        // Server error :(
        console.log(this.responseText)
      }
    }
  }
}



document.addEventListener('submit', handleSubmitEvents, false); // useCapture=false to ensure we bubble upwards (and thus can cancel propagation)
